export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categoryKey: string;
  durationLabel: string;
  minutes: number;
  length: "short" | "medium" | "long";
  views: string;
  likes: string;
  date: string;
  cover: string;
  hot: boolean;
  tags: string[];
  desc: string;
}

export const videos: VideoItem[] = [
  {
    id: "v01",
    title: "新剧开机发布会名场面合集：主演现场互飙高情商发言",
    category: "综艺名场面",
    categoryKey: "variety",
    durationLabel: "03:42",
    minutes: 3,
    length: "short",
    views: "86.4万",
    likes: "5.2万",
    date: "2026-08-17",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20press%20conference%20stage%20with%20warm%20coral%20spotlights%2C%20hosts%20smiling%20in%20front%20of%20brand%20backdrop%2C%20vibrant%20entertainment%20editorial%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=640&height=360&seq=vid-01&orientation=landscape",
    hot: true,
    tags: ["发布会", "高情商", "新剧"],
    desc: "把最近三场新剧发布会的名场面剪在一起，主演互动、记者提问、临场发挥全程高能。",
  },
  {
    id: "v02",
    title: "红毯上的 5 分钟：某颁奖礼明星造型全盘点",
    category: "明星动态",
    categoryKey: "celeb",
    durationLabel: "12:08",
    minutes: 12,
    length: "medium",
    views: "132万",
    likes: "9.8万",
    date: "2026-08-16",
    cover: "https://readdy.ai/api/search-image?query=crowded%20red%20carpet%20with%20warm%20bokeh%20lights%20and%20celebrity%20silhouettes%2C%20flash%20photography%2C%20glamorous%20evening%20gala%2C%20coral%20and%20gold%20ambient%20glow%2C%20entertainment%20editorial%20photography%2C%20soft%20focus%2C%20high%20detail&width=640&height=360&seq=vid-02&orientation=landscape",
    hot: true,
    tags: ["红毯", "颁奖礼", "造型"],
    desc: "红毯现场 5 分钟高光回顾，看造型师如何用色系与剪裁为明星打造全场记忆点。",
  },
  {
    id: "v03",
    title: "片场花絮：吊威亚连拍 12 次的幕后到底有多拼",
    category: "影视花絮",
    categoryKey: "bts",
    durationLabel: "08:21",
    minutes: 8,
    length: "medium",
    views: "58万",
    likes: "3.1万",
    date: "2026-08-16",
    cover: "https://readdy.ai/api/search-image?query=film%20set%20behind%20the%20scenes%20with%20wire%20rig%20and%20green%20screen%2C%20camera%20crew%20working%2C%20warm%20practical%20lights%2C%20cinematic%20BTS%20documentary%20photography%2C%20coral%20and%20amber%20tones%2C%20high%20detail&width=640&height=360&seq=vid-03&orientation=landscape",
    hot: false,
    tags: ["片场", "威亚", "幕后"],
    desc: "走近吊威亚拍摄现场，看动作演员与武指如何配合，一次高难度镜头背后的汗水与坚持。",
  },
  {
    id: "v04",
    title: "演唱会现场：万人合唱的那首开场曲，氛围感拉满",
    category: "明星动态",
    categoryKey: "celeb",
    durationLabel: "18:33",
    minutes: 18,
    length: "medium",
    views: "204万",
    likes: "15.6万",
    date: "2026-08-15",
    cover: "https://readdy.ai/api/search-image?query=stadium%20concert%20crowd%20holding%20phone%20lights%20during%20opening%20song%2C%20warm%20stage%20beams%20in%20coral%20and%20amber%2C%20epic%20atmosphere%2C%20entertainment%20live%20photography%2C%20soft%20haze%2C%20high%20detail&width=640&height=360&seq=vid-04&orientation=landscape",
    hot: true,
    tags: ["演唱会", "合唱", "现场"],
    desc: "开场曲一响，全场手机灯海亮起。这 18 分钟带你重回那晚的万人合唱。",
  },
  {
    id: "v05",
    title: "影视花絮：一场雨戏如何拍出电影级的氛围",
    category: "影视花絮",
    categoryKey: "bts",
    durationLabel: "06:15",
    minutes: 6,
    length: "medium",
    views: "41万",
    likes: "2.4万",
    date: "2026-08-14",
    cover: "https://readdy.ai/api/search-image?query=rainy%20night%20film%20scene%20with%20artificial%20rain%20and%20warm%20lanterns%2C%20actors%20under%20umbrellas%2C%20cinematic%20rain%20photography%2C%20warm%20coral%20and%20amber%20color%20grading%2C%20high%20detail&width=640&height=360&seq=vid-05&orientation=landscape",
    hot: false,
    tags: ["雨戏", "摄影", "氛围"],
    desc: "揭秘雨戏现场的打光与洒水技巧，看看氛围感背后导演和摄影的巧思。",
  },
  {
    id: "v06",
    title: "综艺名场面 TOP10：一句话让全场笑翻的即兴神回应",
    category: "综艺名场面",
    categoryKey: "variety",
    durationLabel: "15:26",
    minutes: 15,
    length: "medium",
    views: "97万",
    likes: "7.7万",
    date: "2026-08-13",
    cover: "https://readdy.ai/api/search-image?query=colorful%20game%20show%20studio%20with%20guests%20laughing%20at%20round%20desk%2C%20bright%20warm%20lights%2C%20confetti%2C%20fun%20vibrant%20variety%20show%20photography%2C%20coral%20and%20gold%20tones%2C%20high%20detail&width=640&height=360&seq=vid-06&orientation=landscape",
    hot: true,
    tags: ["TOP10", "综艺", "即兴"],
    desc: "盘点近期综艺里的即兴名场面，看嘉宾如何用一句话接住全场笑点。",
  },
  {
    id: "v07",
    title: "新剧预告解析：这 3 个镜头藏着整季伏笔",
    category: "影视花絮",
    categoryKey: "bts",
    durationLabel: "22:40",
    minutes: 22,
    length: "long",
    views: "36万",
    likes: "2.1万",
    date: "2026-08-12",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20movie%20still%20with%20dramatic%20chiaroscuro%20lighting%2C%20actor%20in%20mysterious%20mood%20in%20dark%20warm%20scene%2C%20cinematic%20trailer%20photography%2C%20amber%20and%20deep%20brown%20tones%2C%20high%20detail&width=640&height=360&seq=vid-07&orientation=landscape",
    hot: false,
    tags: ["预告", "解析", "伏笔"],
    desc: "从构图、运镜与光影切入，逐帧解析新剧预告里埋下的三个关键伏笔。",
  },
  {
    id: "v08",
    title: "街头采访：路人对明星八卦的第一反应真实到离谱",
    category: "娱乐八卦",
    categoryKey: "gossip",
    durationLabel: "09:54",
    minutes: 9,
    length: "medium",
    views: "64万",
    likes: "4.3万",
    date: "2026-08-11",
    cover: "https://readdy.ai/api/search-image?query=street%20interview%20of%20young%20people%20talking%20on%20sunny%20city%20sidewalk%2C%20handheld%20mic%2C%20warm%20golden%20hour%20light%2C%20candid%20documentary%20photography%2C%20coral%20and%20amber%20tones%2C%20high%20detail&width=640&height=360&seq=vid-08&orientation=landscape",
    hot: false,
    tags: ["街采", "路人", "八卦"],
    desc: "随机街访路人，听听大家追更时最真实的第一反应与吐槽，全程高能。",
  },
  {
    id: "v09",
    title: "幕后探班：一集综艺的妆造准备要花多少小时",
    category: "幕后探班",
    categoryKey: "behind",
    durationLabel: "11:02",
    minutes: 11,
    length: "medium",
    views: "29万",
    likes: "1.8万",
    date: "2026-08-10",
    cover: "https://readdy.ai/api/search-image?query=makeup%20artists%20working%20at%20vanity%20mirror%20backstage%20with%20warm%20vanity%20lights%2C%20beauty%20tools%20and%20brushes%2C%20behind%20the%20scenes%20photography%2C%20coral%20and%20gold%20tones%2C%20soft%20lighting%2C%20high%20detail&width=640&height=360&seq=vid-09&orientation=landscape",
    hot: false,
    tags: ["妆造", "幕后", "综艺"],
    desc: "从凌晨的妆发到临场的换装，看看一集综艺背后化妆团队的分工与时间表。",
  },
  {
    id: "v10",
    title: "颁奖典礼名场面：获奖感言里那些动情瞬间",
    category: "明星动态",
    categoryKey: "celeb",
    durationLabel: "28:47",
    minutes: 28,
    length: "long",
    views: "150万",
    likes: "11.2万",
    date: "2026-08-09",
    cover: "https://readdy.ai/api/search-image?query=elegant%20awards%20ceremony%20stage%20with%20warm%20golden%20spotlights%20and%20trophy%2C%20speaker%20at%20podium%2C%20gala%20photography%2C%20coral%20and%20gold%20ambient%20lighting%2C%20soft%20bokeh%2C%20high%20detail&width=640&height=360&seq=vid-10&orientation=landscape",
    hot: true,
    tags: ["颁奖", "感言", "动情"],
    desc: "一段 28 分钟的获奖感言合集，记录台上台下那些眼眶发热的瞬间。",
  },
  {
    id: "v11",
    title: "新剧开机：主创全员到场，阵容曝光亮点全梳理",
    category: "娱乐八卦",
    categoryKey: "gossip",
    durationLabel: "05:18",
    minutes: 5,
    length: "short",
    views: "47万",
    likes: "3.0万",
    date: "2026-08-08",
    cover: "https://readdy.ai/api/search-image?query=film%20kickoff%20ceremony%20with%20team%20group%20photo%20holding%20red%20ribbon%20scissors%2C%20warm%20coral%20stage%20backdrop%2C%20entertainment%20news%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail&width=640&height=360&seq=vid-11&orientation=landscape",
    hot: false,
    tags: ["开机", "阵容", "新剧"],
    desc: "新剧正式开机，主创全员到齐。这份阵容解析帮你快速理清看点与期待。",
  },
  {
    id: "v12",
    title: "音乐节现场：三首连唱把气氛直接顶到最高点",
    category: "综艺名场面",
    categoryKey: "variety",
    durationLabel: "16:19",
    minutes: 16,
    length: "medium",
    views: "88万",
    likes: "6.6万",
    date: "2026-08-07",
    cover: "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20with%20crowd%20and%20colorful%20lights%20at%20dusk%2C%20warm%20coral%20and%20amber%20stage%20beams%2C%20lively%20energy%2C%20concert%20photography%2C%20high%20detail&width=640&height=360&seq=vid-12&orientation=landscape",
    hot: false,
    tags: ["音乐节", "现场", "连唱"],
    desc: "黄昏的音乐节舞台，三首连唱无缝衔接，镜头记录全场最沸腾的十六分钟。",
  },
];